import { useOrganizationId } from '@/hooks/useSwr';
import ChatPromptIcon from '@/icons/ChatPromptIcon.svg?react';
import { addQueryParams } from '@/utils/add-query-params';
import { appPromptsIndexPath } from '@/utils/constants';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';
import { OrganizationCrumb } from '../Organization/OrganizationCrumb';

export function PromptsCrumb(props: Partial<BreadcrumbData>) {
  const organizationId = useOrganizationId();

  return (
    <>
      <OrganizationCrumb {...props} />
      <Breadcrumb
        {...props}
        name={props.condensed ? '' : 'Prompts'}
        path={addQueryParams(`/${appPromptsIndexPath}`, { organizationId })}
        icon={<ChatPromptIcon className="relative h-4 w-4" />}
        isFirst={false}
      />
    </>
  );
}
